import React from 'react'
import { backendConfig } from '../../../constant/wxConfig'

export default class BGM extends React.Component {

  componentDidMount () {
    this.autoPlayBGM()
  }

  autoPlayBGM = () => {
    const autoPlayMusic = () => {
      // 自动播放音乐效果，解决浏览器或者APP自动播放问题
      const musicInBrowserHandler = () => {
        musicPlay(true);
        document.body.removeEventListener('touchstart', musicInBrowserHandler);
      }
      document.body.addEventListener('touchstart', musicInBrowserHandler);

      // 自动播放音乐效果，解决微信自动播放问题
      const musicInWeixinHandler = () => {
        musicPlay(true);
        document.addEventListener("WeixinJSBridgeReady", function () {
          musicPlay(true);
        }, false);
        document.removeEventListener('DOMContentLoaded', musicInWeixinHandler);
      }
      document.addEventListener('DOMContentLoaded', musicInWeixinHandler);
    }
    const musicPlay = (isPlay) => {
      try {
        var audio = document.getElementById('laotu-bgm');
        if (isPlay && audio.paused) {
          audio.play();
        }
        if (!isPlay && !audio.paused) {
          audio.pause();
        }
      } catch (error) {
      }
    }
    try {
      autoPlayMusic();
    } catch (error) {
    }
  }

  render () {
    return (
      <audio id="laotu-bgm"
        src={backendConfig.serverHost +  "/official/laotu-bgm-low-volume.aac"}
        // src={'https://backend.smhszdh.com/official/laotu-bgm-low-volume.aac'}
        preload="preload" autoPlay="autoplay" loop="loop"></audio>
    )
  }
}


// WEBPACK FOOTER //
// ./src/layouts/PageLayout/BGM.js